function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.97826 3.23926H5.36957C4.88957 3.23926 4.5 3.62882 4.5 4.10882V20.6306C4.5 21.1106 4.88957 21.5001 5.36957 21.5001H18.413C18.893 21.5001 19.2826 21.1106 19.2826 20.6306V4.10882C19.2826 3.62882 18.893 3.23926 18.413 3.23926H15.8043",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1159 2.36957C12.9359 1.86435 12.4585 1.5 11.8916 1.5C11.3246 1.5 10.8463 1.86435 10.6672 2.36957H8.84808C8.36808 2.36957 7.97852 2.75913 7.97852 3.23913V4.1087H15.8046V3.23913C15.8046 2.75913 15.415 2.36957 14.935 2.36957H13.1159V2.36957Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoWhiteboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWhiteboard);
export default __webpack_public_path__ + "static/media/ico-whiteboard.e4dedbef.svg";
export { ForwardRef as ReactComponent };